import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_carrier_service_types_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { serviceTypeIds?: number[], fullTextSearch?: string, carrierId?: number }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string, Services?: { CarrierId?: number, Carrier?: { Id?: number } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { serviceTypeIds?: number[], fullTextSearch?: string, carrierId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string, Services?: { CarrierId?: number, Carrier?: { Id?: number } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { serviceTypeIds?: number[], fullTextSearch?: string, carrierId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string, Services?: { CarrierId?: number, Carrier?: { Id?: number } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      serviceTypeIds?: number[], fullTextSearch?: string, carrierId?: number    }) {
      return false;
    }
}
